import { PartiesService } from './../service/parties.service';
import { Component, Input, OnInit } from '@angular/core';
import { PartyRolesService } from '../service/party-roles.service';
import { PartyContactMechanisms } from '../model/party-contact-mechanisms.model';
import { PartyRoleTypes } from '../model/party-role-types.model';
import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import { SimpleDatePipe } from 'src/app/pipes/simple-date.pipe';

export class partyContactMechanismInterface {
    emails!: { title: string; header: string; enabled: boolean; current: PartyContactMechanisms[]; past: PartyContactMechanisms[] };
    postalAddresses!: { title: string; header: string; enabled: boolean; current: PartyContactMechanisms[]; past: PartyContactMechanisms[] };
    phoneNumbers!: { title: string; header: string; enabled: boolean; current: PartyContactMechanisms[]; past: PartyContactMechanisms[] };
    contactPersons!: { title: string; header: string; enabled: boolean; current: PartyContactMechanisms[]; past: PartyContactMechanisms[] };
}

@Component({
    selector: 'view-party-contact-mechanism',
    templateUrl: './view-party-contact-mechanism.component.html',
    styleUrls: ['./view-party-contact-mechanism.component.scss']
})
export class ViewPartyContactMechanismComponent implements OnInit {
    @Input() partyId!: number;
    @Input() enabledTypes: Array<keyof partyContactMechanismInterface> = ['emails', 'postalAddresses', 'phoneNumbers', 'contactPersons']; // Used to display certain types only
    @Input() filterContactPersonTypes: string[] = [];
    @Input() filterAddressTypes: string[] = [];
    @Input() filterEmailTypes: string[] = [];
    @Input() filterPhoneNumberTypes: string[] = [];
    @Input() removeContactPersonTypes: string[] = [];
    @Input() removeAddressTypes: string[] = [];
    @Input() removeEmailTypes: string[] = [];
    @Input() removePhoneNumberTypes: string[] = [];

    results: partyContactMechanismInterface = {
        postalAddresses: { title: 'Addresses', header: 'Address', enabled: false, current: [], past: [] },
        phoneNumbers: { title: 'Phone Numbers', header: 'Phone', enabled: false, current: [], past: [] },
        emails: { title: 'Emails', header: 'Email', enabled: false, current: [], past: [] },
        contactPersons: { title: 'Contact Persons', header: 'Contact Person', enabled: false, current: [], past: [] }
    };
    partyContactMechanisms: PartyContactMechanisms[] = [];

    isLoading: boolean = false;

    promises: Array<any> = [];

    constructor(
        private partiesService: PartiesService,
        private partyRolesService: PartyRolesService
    ) {}

    ngOnInit(): void {
        this.isLoading = true;

        this.getPartyContactMechanisms();

        Promise.all(this.promises).then((res) => {
            this.isLoading = false;
        });
    }

    getPartyContactMechanisms() {
        let deferred = new Promise((resolve, reject) => {
            this.partiesService.getPartyContactMechanisms(this.partyId).subscribe((res) => {
                if (res.partyContactMechanisms) {
                    this.partyContactMechanisms = res.partyContactMechanisms;

                    this.removePartyContactMechanisms();
                    this.buildPartyContactMechanisms();

                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    removePartyContactMechanisms() {
        if (this.partyContactMechanisms && this.partyContactMechanisms.length > 0) {
            this.removeContactPersonTypes.forEach((type) => {
                this.partyContactMechanisms = this.partyContactMechanisms.filter((pcm) => {
                    return pcm.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE !== type;
                });
            });
            this.removeAddressTypes.forEach((type) => {
                this.partyContactMechanisms = this.partyContactMechanisms.filter((pcm) => {
                    return pcm.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE !== type;
                });
            });
            this.removeEmailTypes.forEach((type) => {
                this.partyContactMechanisms = this.partyContactMechanisms.filter((pcm) => {
                    return pcm.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE !== type;
                });
            });
            this.removePhoneNumberTypes.forEach((type) => {
                this.partyContactMechanisms = this.partyContactMechanisms.filter((pcm) => {
                    return pcm.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE !== type;
                });
            });
        }
    }

    buildPartyContactMechanisms() {
        this.enabledTypes.forEach((enabledType) => {
            this.results[enabledType].enabled = true;
        });

        this.cleanDates();

        this.partyContactMechanisms
            .sort((a, b) => {
                return b.CREATED_DATE!.getTime() - a.CREATED_DATE!.getTime();
            })
            .forEach((pcm) => {
                switch (pcm.CONTACT_MECHANISMS!.CONTACT_MECHANISM_TYPES!.TYPE) {
                    case 'Address':
                        if (
                            this.results?.postalAddresses?.current[0]?.ID
                                ? this.results!.postalAddresses!.current.find(
                                      (cur) =>
                                          cur.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE ===
                                          pcm.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE
                                  )
                                    ? false
                                    : true
                                : true
                        ) {
                            this.results.postalAddresses.current.push(pcm);
                        } else {
                            this.results.postalAddresses.past.push(pcm);
                        }
                        break;
                    case 'Phone':
                        if (
                            this.results?.phoneNumbers?.current[0]?.ID
                                ? this.results!.phoneNumbers!.current.find(
                                      (cur) =>
                                          cur.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE ===
                                          pcm.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE
                                  )
                                    ? false
                                    : true
                                : true
                        ) {
                            this.results.phoneNumbers.current.push(pcm);
                        } else {
                            this.results.phoneNumbers.past.push(pcm);
                        }
                        break;
                    case 'Email':
                        if (
                            this.results?.emails?.current[0]?.ID
                                ? this.results!.emails!.current.find(
                                      (cur) =>
                                          cur.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE ===
                                          pcm.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE
                                  )
                                    ? false
                                    : true
                                : true
                        ) {
                            this.results.emails.current.push(pcm);
                        } else {
                            this.results.emails.past.push(pcm);
                        }
                        break;
                    case 'Contact Person':
                        if (
                            this.results?.contactPersons?.current[0]?.ID
                                ? this.results!.contactPersons!.current.find(
                                      (cur) =>
                                          cur.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE ===
                                          pcm.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE
                                  )
                                    ? false
                                    : true
                                : true
                        ) {
                            this.results.contactPersons.current.push(pcm);
                        } else {
                            this.results.contactPersons.past.push(pcm);
                        }
                        break;
                }
            });
    }

    cleanDates() {
        this.partyContactMechanisms.forEach((pcm) => {
            pcm.CREATED_DATE = new CleanDatePipe().transform(pcm.CREATED_DATE!);
        });
    }
}
